import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	render() {
		if (this.state.hasError) {
			return (
				this.props.fallback ?? (
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							padding: '48px',
							gap: '16px',
						}}
					>
						<Typography variant="h5">
							Something went wrong.
						</Typography>
						<Button
							variant="outlined"
							onClick={() => window.location.reload()}
						>
							Reload page
						</Button>
					</div>
				)
			);
		}

		return this.props.children;
	}
}
